import { QuestionBase } from '@app/core/models/question/question-base';

export class GaugeChartQuestion extends QuestionBase<number> {
  controlType = 'gauge-chart';
  labels = [];

  constructor(options: any = {}) {
    super(options);

    this.labels = options['labels'];
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/question/gauge-chart-question.ts